import { render, staticRenderFns } from "./RoleConfigWindow.vue?vue&type=template&id=a9e59bf4&scoped=true&"
import script from "./RoleConfigWindow.vue?vue&type=script&lang=js&"
export * from "./RoleConfigWindow.vue?vue&type=script&lang=js&"
import style0 from "./RoleConfigWindow.vue?vue&type=style&index=0&id=a9e59bf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e59bf4",
  null
  
)

export default component.exports